import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewCart from 'Views/view-cart';

"use strict";

// Global requires
whenDomReady(function(){
  console.log('init cart');
    new ViewCart({el: $('#MainContent')});
});